import { CLEAR_ACCESS_CODE_RESULT } from 'actiontypes/accessCodes';

export default function clearAccessCodeResult(result) {
  return { type: CLEAR_ACCESS_CODE_RESULT, payload: result };
}